import { useContext } from "react";

import { LangContext } from "../../../context/LangContext";

import "./style.css"

function Modal({ type, isOpen, work, setWork }) {
    const { language } = useContext(LangContext);

    const addInput = () => {
        setWork({
            ...work,
            [`awards_${language}`]: [...work[`awards_${language}`], '']
        })
    }

    const delInput = () => {
        if (work[`awards_${language}`].length <= 1) return

        const newAwards = [...work[`awards_${language}`]];
        newAwards.pop();

        setWork({
            ...work,
            [`awards_${language}`]: newAwards
        });
    }

    const setValue = (e, idx) => {
        const value = e.target.value;

        let newAwards = [...work[`awards_${language}`]];
        newAwards[idx] = value;

        setWork({
            ...work,
            [`awards_${language}`]: newAwards
        })
    }

    return type && (
        <div className="mdl_awards_amazon">
            <button
                onClick={() => isOpen(null)}
                className='btn_close_awards_amazon'
            ></button>

            {type === 'amazon' &&
                <div className="content">
                    <span>Lien vers amazon</span>

                    <input
                        type="text"
                        placeholder='"https://lien-amazon.com"'

                        value={work.amazon}
                        onChange={(e) => setWork({ ...work, amazon: e.target.value })}
                    />
                </div>
            }

            {type === 'awards' &&
                <div className="content">
                    <span>Liste de récompences</span>

                    <ul>
                        {work[`awards_${language}`].length !== 0 && work[`awards_${language}`].map((value, idx) => (
                            <li key={idx}>
                                <input
                                    type="text"
                                    placeholder={`Description de la récompence en ${language === 'fr' ? '"Français"' : '"Anglais"'}`}

                                    value={value}
                                    onChange={(e) => setValue(e, idx)}
                                />
                            </li>
                        ))}
                    </ul>

                    <div className="panel">
                        <button
                            className="add_input"
                            onClick={() => addInput()}
                        >plus</button>

                        <button
                            className="del_input"
                            onClick={() => delInput()}
                        >moins</button>
                    </div>
                </div>
            }
        </div>
    )
}

export default Modal;